var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_1604)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_1604)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8613 20.505L22.9481 27.8814C22.1188 28.2917 22.1274 29.7 22.9619 30.0954L37.9373 37.1943C39.2531 37.818 40.7184 37.818 42.0341 37.1943L57.0097 30.0952C57.844 29.7 57.8531 28.2919 57.0233 27.8817L42.1106 20.5047C40.75 19.8318 39.2216 19.8318 37.8611 20.5047",
    fill: "#A6A6C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3145 41.0704V58.8045C41.3145 59.6477 42.026 60.2256 42.6819 59.9148L59.369 52.1722C59.5551 52.084 59.7148 51.931 59.8273 51.733C59.9397 51.535 59.9999 51.3012 59.9998 51.0619V33.3281C59.9998 32.4846 59.2883 31.907 58.6324 32.2178L41.9453 39.9604C41.7592 40.0487 41.5996 40.2017 41.4871 40.3996C41.3746 40.5976 41.3145 40.8311 41.3145 41.0704Z",
    fill: "#C0C0D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4179 41.9855L32.4655 44.8438L31.9627 45.1343L21.5085 51.1221C20.846 51.5043 20 50.927 20 50.047V33.4023C20 33.0839 20.1366 32.8091 20.3197 32.6023C20.3948 32.5129 20.4801 32.4365 20.5729 32.3753C20.8225 32.1961 21.1789 32.1483 21.4818 32.2915L37.3347 39.8001C38.1405 40.1822 38.2038 41.5317 37.4179 41.9855Z",
    fill: "#D9D9E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.418 41.9855L32.4656 44.8438L20.3198 32.6021C20.395 32.5127 20.4802 32.4364 20.5731 32.3753C20.8227 32.1961 21.179 32.1483 21.482 32.2915L37.3348 39.8001C38.1406 40.1822 38.2039 41.5317 37.418 41.9855Z",
    fill: "#8181B1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_1604",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_1604",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg23);
export default __webpack_public_path__ + "static/media/productivityimg23.dafab0c0c2dfd3d085e6a2595bec9187.svg";
export { ForwardRef as ReactComponent };